import { AxiosPromise } from 'axios';

import { CheckCodeParams, CheckCodeResponse } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

export const checkCode = async (params: CheckCodeParams): AxiosPromise<CheckCodeResponse> =>
  apiInstance.get('/translations/check-code', {
    params,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
